import * as React from "react";
const SvgPhoneVerification = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath="url(#phone_verification_svg__a)">
      <path fill="#fff" d="M0 0h72v72H0z" />
      <path
        d="m10.432 43.873-.105.172a6.5 6.5 0 0 0 2.199 8.926l.172.104M4.11 43.505v0c-2.646 4.848-.84 10.994 4.009 13.639v0M58.912 24.738l.177.098a6.5 6.5 0 0 1 2.55 8.831l-.098.177M64.207 20.873v0c4.712 2.88 6.214 9.108 3.334 13.82v0"
        stroke="#8559EC"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x={18}
        y={10}
        width={32}
        height={56}
        rx={3}
        transform="rotate(-5 18 10)"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m35.5 60.864 5.977-.523"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x={30.336}
        y={13.313}
        width={8}
        height={1}
        rx={0.5}
        transform="rotate(-5 30.336 13.313)"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.362 36.611a7 7 0 0 1 6.363-7.583v0a7 7 0 0 1 7.584 6.363l.784 8.966-13.947 1.22-.784-8.966ZM28.154 45.751l17.932-1.569M35.508 26.537l.218 2.49"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="phone_verification_svg__a">
        <path fill="#fff" d="M0 0h72v72H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPhoneVerification;
